import DialogList from './DialogList';

export default DialogList;
